import { render, staticRenderFns } from "./Quize.vue?vue&type=template&id=56cf892e"
import script from "./Quize.vue?vue&type=script&lang=js"
export * from "./Quize.vue?vue&type=script&lang=js"
import style0 from "./Quize.vue?vue&type=style&index=0&id=56cf892e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports